import logo from '@/assets/Icono-macroindustrial.png';

const LoadingFallback = () => {
  return (
    <div className="flex justify-center items-center h-screen overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white dark:from-gray-900 dark:via-gray-700 dark:to-gray-900">
      <div className="flex flex-col items-center">
        <img 
          src={logo} 
          alt="Loading..."
          className="w-150 h-150 object-contain"
          style={{
            animation: 'fadeEffect 6s ease-in-out infinite'
          }}
        />
      </div>
      <style>{`
        @keyframes fadeEffect {
          0% { opacity: 0.3; transform: scale(0.95); }
          50% { opacity: 1; transform: scale(1); }
          100% { opacity: 0.3; transform: scale(0.95); }
        }
      `}</style>
    </div>
  );
};

export default LoadingFallback;